import {
    Box,
    Button,
    List,
    ListItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/superadmin/message-details.module.scss";
// import styles from "../../styles/pages/mymessage.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";

const responseStatusList = [
    "Need your reply",
    "Awaiting your reply",
    "Pending",
    "Awaiting recipient’s reply",
];

const MessageStatus = (props) => {
    return (
        <>
            <Box className={`${styles.msgdetails} ${styles.statusCard}`}>
                <Paper className={styles.styledPaper}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.statusHeading}
                    >
                        <Typography variant="caption">Status:</Typography>
                        <Typography
                            variant="button"
                            className={props?.status?.class}
                        >
                            {props?.status?.name}
                        </Typography>
                    </Stack>
                    {props?.resolved_by ? (
                        <List>
                            <ListItem sx={{ textTransform: "capitalize" }}>
                                <span>By:</span>
                                {props?.resolved_by?.name ||
                                props?.resolved_by?.last_name
                                    ? `${props?.resolved_by?.name} ${props?.resolved_by?.last_name}`
                                    : "N/A"}
                            </ListItem>
                            <ListItem>
                                <span>On:</span>
                                {props?.resolved_at
                                    ? props?.resolved_at
                                    : "N/A"}
                            </ListItem>
                        </List>
                    ) : (
                        ""
                    )}
                    <Box className={styles.statusBtnGroup}>
                        {responseStatusList.includes(props?.status?.name) ? (
                            <Button
                                className={styles.btnRspond}
                                onClick={() => {
                                    if (!props?.respondToInquiry) {
                                        props?.setRespondToInquiry(true);
                                    }
                                }}
                            >
                                Respond
                            </Button>
                        ) : (
                            <Button
                                className={`${styles.btnRspond} ${styles.btnOpenAgain}`}
                                onClick={props?.open_inquiry}
                            >
                                Open Again
                            </Button>
                        )}
                        {responseStatusList.includes(props?.status?.name) ? (
                            <Button
                                className={`${styles.btnResolve} ${styles.btnResolveLrg}`}
                                onClick={props?.mark_resolved}
                            >
                                {props?.inquiry_video ? (
                                    <>Close this convo</>
                                ) : (
                                    <>Close Ticket</>
                                )}
                            </Button>
                        ) : !props?.archived ? (
                            <Button
                                className={`${styles.btnResolve} ${styles.btnArchiveGray}`}
                                onClick={props?.archive_inquiry}
                            >
                                Archive
                            </Button>
                        ) : (
                            ""
                        )}
                    </Box>
                </Paper>
            </Box>
        </>
    );
};

export default MessageStatus;
